// extracted by css-extract-rspack-plugin
export default {"cls1":"StickyWorkCardHeader-cls1_5_k","cls2":"StickyWorkCardHeader-cls2_wEC StickyWorkCardHeader-cls1_5_k"};